import React from 'react';
import { Link } from 'react-router-dom';

const Thankyou = () => {
  return (
    <div className="justify-content-center align-items-center mt-5 py-5 bg-light text-center">
      <div>
        <h1 className="mb-4 green_grad fw-bold">Thank You!</h1>
        <p className="mb-3 fs-5">Your enquiry has been successfully submitted.</p>
        <p className="mb-3 fs-5">Our Team will get back to you soon!</p>
        <Link to="/" className="btn btn-purple">
          Go Back to Home
        </Link>
      </div>
    </div>
  );
};

export default Thankyou;
